import React from "react";
import { Card, CardActionArea } from "@mui/material";
import { myStyles } from "components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function CardSendNotification({
  id,
  title,
  handleSendNotification,
  disabled = false,
}) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!disabled) {
      handleSendNotification(id);
    }
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        ...myStyles.cardSelectionRequired,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <CardActionArea
        sx={{
          ...myStyles.cardSelectionRequiredAction,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        disabled={disabled}
      >
        <h3>{t(title)}</h3>
      </CardActionArea>
    </Card>
  );
}

export default CardSendNotification;
